// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headlineItem":"headlineItem_Zk+5n","headlineItem__img":"headlineItem__img_RQuC+","headlineItem__mask":"headlineItem__mask_bBcxK","ui_mask":"ui_mask_Lrpqb"};